var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "f_stories-online-document",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes heartbeat{0%,30%,40%,60%,to{transform:scale(1)}10%,50%{transform:scale(1.1)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#f_stories-online-document:not(.animated) .animable{opacity:0}")), /*#__PURE__*/React.createElement("g", {
    id: "f--background-complete--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "250px 382.525px"
    },
    id: "elr93w964moih",
    className: "animable",
    d: "M0 382.4h500v.25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "433.34px 398.615px"
    },
    id: "elwbw1oqf7tfn",
    className: "animable",
    d: "M416.78 398.49h33.12v.25h-33.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "326.875px 401.335px"
    },
    id: "elg4iff24df4w",
    className: "animable",
    d: "M322.53 401.21h8.69v.25h-8.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "406.185px 389.335px"
    },
    id: "elgnjzyoc6pn",
    className: "animable",
    d: "M396.59 389.21h19.19v.25h-19.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "74.055px 391.015px"
    },
    id: "el57oyzeq9run",
    className: "animable",
    d: "M52.46 390.89h43.19v.25H52.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "107.725px 391.015px"
    },
    id: "eltlytutywf4h",
    className: "animable",
    d: "M104.56 390.89h6.33v.25h-6.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "178.31px 395.235px"
    },
    id: "el40ywafc65f6",
    className: "animable",
    d: "M131.47 395.11h93.68v.25h-93.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 337.8H43.91a5.71 5.71 0 0 1-5.7-5.71V60.66a5.71 5.71 0 0 1 5.7-5.66H237a5.71 5.71 0 0 1 5.71 5.71v271.38a5.71 5.71 0 0 1-5.71 5.71zM43.91 55.2a5.46 5.46 0 0 0-5.45 5.46v271.43a5.46 5.46 0 0 0 5.45 5.46H237a5.47 5.47 0 0 0 5.46-5.46V60.66A5.47 5.47 0 0 0 237 55.2z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el8ac7ok4a5kk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31 337.8h-193.1a5.72 5.72 0 0 1-5.71-5.71V60.66a5.72 5.72 0 0 1 5.71-5.66h193.1a5.71 5.71 0 0 1 5.69 5.66v271.43a5.71 5.71 0 0 1-5.69 5.71zM260.21 55.2a5.47 5.47 0 0 0-5.46 5.46v271.43a5.47 5.47 0 0 0 5.46 5.46h193.1a5.47 5.47 0 0 0 5.46-5.46V60.66a5.47 5.47 0 0 0-5.46-5.46z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "356.75px 196.4px"
    },
    id: "eltaxstr4ntve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "126.94px 327.67px"
    },
    id: "elhmuxwsgd16r",
    className: "animable",
    d: "M118.94 318.39v14.2l-6 4.36h28l-8.94-3.32v-14.25l-13.06-.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.47 336.54v44.73h125v-44.73zm122.75 17.52H94.38v-14.62h97.84z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "131.97px 358.905px"
    },
    id: "el5go86wima9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.37 336.54v44.73h103.1v-44.73zm100.85 17.52H94.38v-14.62h97.84z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "142.92px 358.905px"
    },
    id: "eli91isda7z9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "182.135px 346.75px"
    },
    id: "el7qqtyni07nj",
    className: "animable",
    d: "M172.05 339.44h20.17v14.62h-20.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "106.855px 350.405px"
    },
    id: "el68y9c7ehrhk",
    className: "animable",
    d: "M94.38 346.75h24.95v7.31H94.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "130.56px 351.88px"
    },
    id: "el6n7upnmj5f",
    className: "animable",
    d: "M121.17 349.71h18.78v4.34h-18.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "153.235px 349.62px"
    },
    id: "elvl2rh3ye26",
    className: "animable",
    d: "M144.29 345.18h17.89v8.88h-17.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "110.115px 366.945px"
    },
    id: "ellyiadg7b7r",
    className: "animable",
    d: "m112.11 357.24-.53 1.75h-7.18l-.54-1.75h-9.48v19.41h31.47v-19.41h-13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "143.255px 366.945px"
    },
    id: "elhcu85gwayl7",
    className: "animable",
    d: "m149.51 357.24-.54 1.75h-7.18l-.54-1.75h-13.73v19.41h31.47v-19.41h-9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "176.395px 366.945px"
    },
    id: "elpfm91t5d1v",
    className: "animable",
    d: "m178.39 357.24-.53 1.75h-7.18l-.54-1.75h-9.48v19.41h31.47v-19.41h-13.74z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 266.42,
    width: 100.05,
    height: 60.45,
    rx: 3.53,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "129.695px 296.645px"
    },
    id: "elnnqeomhp9h8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.02,
    y: 266.42,
    width: 100.05,
    height: 60.45,
    rx: 3.53,
    style: {
      fill: "#e6e6e6",
      transformOrigin: "132.045px 296.645px"
    },
    id: "elgjzyvd0i2zo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "132.05px 296.645px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    d: "M104.76 249.56h54.58v94.17h-54.58z",
    id: "ell4mqw9oniq7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87 261.18h89.54A17.58 17.58 0 0 1 418 278.76v69.92H293.29v-69.92a17.58 17.58 0 0 1 17.58-17.58z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "355.645px 304.93px"
    },
    id: "eltgxo8l2jru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.82 313h16a10.45 10.45 0 0 1 10.45 10.45v57.82h-36.9v-57.82A10.45 10.45 0 0 1 266.82 313z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "274.82px 347.135px"
    },
    id: "eleuwk4cpz2c8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.82 313h.33a10.45 10.45 0 0 1 10.45 10.45v57.82h-21.23v-57.82A10.45 10.45 0 0 1 266.82 313z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "266.985px 347.135px"
    },
    id: "eltb1ano9yoni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "343.51px 367.99px"
    },
    id: "elz6pju6z3h4h",
    className: "animable",
    d: "M282.07 354.71h122.88v26.56H282.07z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.28,
    y: 330.42,
    width: 139.75,
    height: 27.87,
    rx: 10.62,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "341.155px 344.355px"
    },
    id: "el0aoqgb7afld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.89,
    y: 330.42,
    width: 35.95,
    height: 27.87,
    rx: 10.62,
    style: {
      fill: "#e0e0e0",
      isolation: "isolate",
      transformOrigin: "392.865px 344.355px"
    },
    id: "elwu6cfn0ha5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.79 313h16a10.45 10.45 0 0 1 10.45 10.45v57.82h-36.9v-57.82A10.45 10.45 0 0 1 401.79 313z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "409.79px 347.135px"
    },
    id: "eln6z8kodb21e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.79 313h.34a10.45 10.45 0 0 1 10.45 10.45v57.82h-21.24v-57.82A10.45 10.45 0 0 1 401.79 313z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "401.96px 347.135px"
    },
    id: "eljjdbw4a9gf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "365.375px 167.67px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    d: "M306.06 106.38h118.63v122.58H306.06z",
    id: "elbl2yrasg1a8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "361.235px 167.67px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    d: "M301.92 106.38h118.63v122.58H301.92z",
    id: "elx4q9ab2k9q"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "361.31px 167.695px"
    },
    id: "el97bmwcrb5a",
    className: "animable",
    d: "M305.06 109.28h112.5v116.83h-112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "362.715px 167.695px"
    },
    id: "elwpez4452hkd",
    className: "animable",
    d: "M307.87 109.28h109.69v116.83H307.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "362.695px 167.695px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    d: "M361.58 109.28h2.23v116.83h-2.23z",
    id: "el8t0uiqssmvi"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "331.67px 167.695px"
    },
    id: "elxw8uaqdh56m",
    className: "animable",
    d: "m348.8 109.28-31.26 116.83h-3l31.26-116.83h3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "361.585px 167.915px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    d: "M360.63 107.48h1.91v120.87h-1.91z",
    id: "eles45c64loiq"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "322.66px 164.56px"
    },
    id: "elq7w1qkghmiq",
    className: "animable",
    d: "m337.45 109.28-29.58 110.56v-60.77l13.32-49.79h16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "403.345px 172.995px"
    },
    id: "eldkhhkn6n67",
    className: "animable",
    d: "M417.56 119.88v11.22l-25.43 95.01h-3l28.43-106.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "406.38px 184.32px"
    },
    id: "el1dckwfjvw7s",
    className: "animable",
    d: "M417.56 142.53v60.77l-6.1 22.81H395.2l22.36-83.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "133.575px 157.06px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    d: "M97.66 113.36h71.83v87.4H97.66z",
    id: "elw5lbw2sios"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "131.425px 157.2px"
    },
    id: "eliapfjt41ob",
    className: "animable",
    d: "m114.1 179.12 37.74-37.1-40.83-6.74 3.09 43.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "137.56px 156.245px"
    },
    id: "eluqb7h1x7v79",
    className: "animable",
    d: "m150.93 170.32 1.87-28.45-28.42 6.98-2.06 21.77 28.61-.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.75,
    cy: 130.29,
    r: 11.47,
    style: {
      fill: "#fafafa",
      transformOrigin: "113.75px 130.29px",
      transform: "rotate(-45deg)"
    },
    className: "animable",
    id: "el4nytf0zqi2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.22 180.46a5.57 5.57 0 1 1 5.56 5.57 5.56 5.56 0 0 1-5.56-5.57z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "152.79px 180.46px"
    },
    id: "el19pgln4rfo3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "143.43px 179.79px"
    },
    id: "el7ns5cb4v4ne",
    className: "animable",
    d: "m151.46 190.24-16.06-9.78 13.5-11.12 2.56 20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "130.91px 159.375px"
    },
    id: "elax8babbxxjc",
    className: "animable",
    d: "M129.33 124.48h3.16v69.79h-3.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "160.705px 157.83px"
    },
    id: "elw33drb6emcd",
    className: "animable",
    d: "M158.66 124.48h4.09v66.7h-4.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "115.31px 181.06px"
    },
    id: "elo19wllir3i",
    className: "animable",
    d: "M104.87 170.62h20.88v20.88h-20.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--Shadow--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "f--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--Device--inject-2",
    className: "animable",
    style: {
      transformOrigin: "303.545px 317.45px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.36 236h208.36a4.27 4.27 0 0 1 4.27 4.27V391h-216.9V240.31a4.27 4.27 0 0 1 4.27-4.31z",
    style: {
      fill: "#263238",
      transformOrigin: "303.54px 313.5px"
    },
    id: "elvx34zkcb8kb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "303.54px 312.195px"
    },
    id: "elxtnp12lhutj",
    className: "animable",
    d: "M199.36 245.61h208.36v133.17H199.36z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.64,
    cy: 241.2,
    r: 2.08,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "301.64px 241.2px"
    },
    className: "animable",
    id: "elsw97jn8tj5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.95,
    cy: 241.2,
    r: 1.56,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "305.95px 241.2px"
    },
    className: "animable",
    id: "ely2ye8k6yqnf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39 381.51a2.66 2.66 0 0 0-.85-.15 2.73 2.73 0 1 0 2.73 2.73.68.68 0 0 0 0-.15 2.72 2.72 0 0 1-1.88-2.43z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "303.542px 384.09px"
    },
    className: "animable",
    id: "elb4kltcyl0nh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.16 388.88v2a2.9 2.9 0 0 1-2.06 2.76l-15.1 4.42a20.16 20.16 0 0 1-5.78.84H201.88a20.14 20.14 0 0 1-5.77-.84L181 393.6a2.9 2.9 0 0 1-2.07-2.76v-2z",
    style: {
      fill: "#263238",
      transformOrigin: "303.545px 393.87px"
    },
    id: "elvhdfk6ofbz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.16 388.88v2a2.9 2.9 0 0 1-2.06 2.76l-15.1 4.42a20.16 20.16 0 0 1-5.78.84H201.88a20.14 20.14 0 0 1-5.77-.84L181 393.6a2.9 2.9 0 0 1-2.07-2.76v-2z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "303.545px 393.87px"
    },
    className: "animable",
    id: "el065m41mgu7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.16 388.88v2a2.85 2.85 0 0 1-.41 1.47H179.34a2.85 2.85 0 0 1-.41-1.47v-2z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "303.545px 390.615px"
    },
    className: "animable",
    id: "eloamhr3y1c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.08 388.88v.86a.85.85 0 0 1-.85.85h-33.36a.85.85 0 0 1-.86-.85v-.86z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "303.545px 389.735px"
    },
    className: "animable",
    id: "ele6od87jw485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.72 245.61S378.91 360 199.36 378.78V245.61z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate",
      transformOrigin: "303.54px 312.195px"
    },
    className: "animable",
    id: "ellq9jq22b5qc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--window-3--inject-2",
    className: "animable",
    style: {
      transformOrigin: "334.725px 264.92px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 193.47v125.26l-20.86 20.86h-82.48a3.22 3.22 0 0 1-3.21-3.22v-142.9a3.22 3.22 0 0 1 3.21-3.22h100.1a3.22 3.22 0 0 1 3.24 3.22z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "334.725px 264.92px"
    },
    id: "elxv8mep9g7lo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 198.94v119.79l-20.86 20.86h-82.48a3.22 3.22 0 0 1-3.21-3.22V198.94z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "334.725px 269.265px"
    },
    className: "animable",
    id: "eltf7pfgvssv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.2 194.23a1.56 1.56 0 1 1-1.56-1.55 1.55 1.55 0 0 1 1.56 1.55z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "383.64px 194.24px"
    },
    className: "animable",
    id: "el1jrtcvyf49r"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.26 194.23a1.55 1.55 0 1 1-1.55-1.55 1.54 1.54 0 0 1 1.55 1.55z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "377.71px 194.23px"
    },
    className: "animable",
    id: "eleyxrpvjoyvq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.33 194.23a1.56 1.56 0 1 1-1.55-1.55 1.55 1.55 0 0 1 1.55 1.55z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "371.77px 194.24px"
    },
    className: "animable",
    id: "elhqmmixjn0af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.2 208.59h-57.1a1 1 0 0 1 0-2h57.1a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "317.65px 207.59px"
    },
    id: "eldj1qmfsrqet",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.06 214.06h-41a1 1 0 0 1 0-2h41a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "309.56px 213.06px"
    },
    id: "el8d3qk7dc0la",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 298.52h-73a1 1 0 1 1 0-2h73a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "337.83px 297.52px"
    },
    id: "elphqr9zgbx6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.12 320.37h-73a1 1 0 0 1 0-2h73a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "325.62px 319.37px"
    },
    id: "elqjbmgmu208j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 304H289.1a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "331.715px 303px"
    },
    id: "elh1hin01ypth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 309.45H289.1a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "331.715px 308.45px"
    },
    id: "el3zlx354sefk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 314.91H289.1a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "331.715px 313.91px"
    },
    id: "elt026gsx6579",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.5,
      transformOrigin: "377.55px 329.16px"
    },
    className: "animable",
    d: "m387.98 318.73-20.86 20.86v-20.86h20.86z",
    id: "el22m017r3ays"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "385.035px 258.835px"
    },
    className: "animable",
    d: "M382.09 198.94h5.89v119.79h-5.89z",
    id: "eluipyg9e7buq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 261.53a2.17 2.17 0 0 1-2.17-2.17v-12.24A2.17 2.17 0 0 1 385 245a2.17 2.17 0 0 1 2.17 2.17v12.24a2.17 2.17 0 0 1-2.17 2.12z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "385px 253.265px"
    },
    id: "el2nc9468nnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 268.52h-73a1 1 0 1 1 0-2h73a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "337.83px 267.52px"
    },
    id: "elqbmogrt8ci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.12 290.37h-73a1 1 0 0 1 0-2h73a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "325.62px 289.37px"
    },
    id: "el9mi6a4vvn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 274H289.1a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "331.715px 273px"
    },
    id: "el5p6nhr0uucm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 279.45H289.1a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "331.715px 278.45px"
    },
    id: "elhvves5srlt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 284.91H289.1a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "331.715px 283.91px"
    },
    id: "el0k14jnvrx9ii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "331.58px 236.52px"
    },
    id: "el58w1ry08hpm",
    className: "animable",
    d: "M288.84 220.57h85.48v31.9h-85.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "331.585px 233.96px"
    },
    className: "animable",
    d: "M288.84 247.35h2.33v-5.8h2.68V230.1h3.74v7.05h5.14v9.37h6.13v-6.53h5.07l3.35-3.36v-7.77h2.05v11.13h5.16v3.96h5.34v-20.2l1.48-1.48v5.54h3.41v2.49l3.27 3.28v5.91h4.7v-4.68h12.26v-3.49h2.77v-6.1h.99v9.59h1.56l3.53-3.53h3.32v-3.19h1.68v3.23h2.17v13.22h2.36v-6.6l1 .06v-17.43h-85.49v26.78z",
    id: "elqpmby5z7su"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33 257.52h-23a1 1 0 1 1 0-2h23a1 1 0 1 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "362.83px 256.52px"
    },
    id: "el2x6o28c800b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.7 190.25v103.52L307 309.51h-25.55v-116a3.22 3.22 0 0 1 3.21-3.22z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "302.075px 249.88px"
    },
    className: "animable",
    id: "elhc42nca5g95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 261.53a2.17 2.17 0 0 1-2.17-2.17v-12.24A2.17 2.17 0 0 1 385 245a2.17 2.17 0 0 1 2.17 2.17v12.24a2.17 2.17 0 0 1-2.17 2.12z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "385px 253.265px"
    },
    className: "animable",
    id: "elxg5p95l5ml8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--window-1--inject-2",
    className: "animable",
    style: {
      transformOrigin: "208.475px 280.535px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.74 209.08v125.26l-20.86 20.86h-82.46a3.22 3.22 0 0 1-3.21-3.22v-142.9a3.22 3.22 0 0 1 3.21-3.22h100.1a3.22 3.22 0 0 1 3.22 3.22z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "208.475px 280.53px"
    },
    id: "elnpi5n1fq13",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74 214.56v119.79l-20.86 20.86h-82.46a3.22 3.22 0 0 1-3.21-3.22V214.56z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "208.475px 284.885px"
    },
    className: "animable",
    id: "el2467lnnjys7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 209.85a1.56 1.56 0 1 1-1.56-1.55 1.55 1.55 0 0 1 1.56 1.55z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "257.44px 209.86px"
    },
    className: "animable",
    id: "elu5txa1zmtn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 209.85a1.56 1.56 0 1 1-1.55-1.55 1.54 1.54 0 0 1 1.55 1.55z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "251.44px 209.86px"
    },
    className: "animable",
    id: "elljim1mwqc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.09 209.85a1.56 1.56 0 1 1-1.56-1.55 1.55 1.55 0 0 1 1.56 1.55z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "245.53px 209.86px"
    },
    className: "animable",
    id: "elaqlp3za2m7u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6 224.75h-17.74a1 1 0 0 1 0-2h17.74a1 1 0 1 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "171.73px 223.75px"
    },
    id: "ele4my10box9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 230.21h-26.1a1 1 0 0 1 0-2H189a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "175.95px 229.21px"
    },
    id: "elnqciiw9e0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89 235.67h-18a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "171.89px 234.67px"
    },
    id: "elvd19ravm61",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.08 325.14h-73a1 1 0 0 1 0-2h73a1 1 0 1 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "211.58px 324.14px"
    },
    id: "elacj8sjrly6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.08 330.6h-45.22a1 1 0 0 1 0-2h45.22a1 1 0 1 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "185.47px 329.6px"
    },
    id: "elytsnl2cdicg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.5,
      transformOrigin: "251.31px 344.78px"
    },
    className: "animable",
    d: "m261.74 334.35-20.86 20.86v-20.86h20.86z",
    id: "el091a5o8gf7ch"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "258.795px 274.455px"
    },
    className: "animable",
    d: "M255.85 214.56h5.89v119.79h-5.89z",
    id: "el4c3ncy0zvn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.79 326.15a2.17 2.17 0 0 1-2.17-2.17v-12.24a2.17 2.17 0 0 1 2.17-2.17 2.17 2.17 0 0 1 2.17 2.17V324a2.17 2.17 0 0 1-2.17 2.15z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.79px 317.86px"
    },
    id: "elv2xuql73j5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.08 224.75h-13.73a1 1 0 0 1 0-2h13.73a1 1 0 1 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "241.215px 223.75px"
    },
    id: "elyxp3ghw7bmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.08 230.21H241a1 1 0 0 1 0-2h7.1a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "244.55px 229.21px"
    },
    id: "elo71eqa2rk0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.08 250.14h-73a1 1 0 0 1 0-2h73a1 1 0 1 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "211.58px 249.14px"
    },
    id: "el4791y22jj48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.08 255.6h-85.22a1 1 0 0 1 0-2h85.22a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "205.47px 254.6px"
    },
    id: "elhs3o0mdwqgq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08 261.06h-35.22a1 1 0 0 1 0-2h35.22a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "180.47px 260.06px"
    },
    id: "elb43ta47x8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.7,
      transformOrigin: "193.79px 272.81px"
    },
    className: "animable",
    d: "M177 268.31h33.58v9H177z",
    id: "elt7iyn8moiw8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.3,
      transformOrigin: "184.605px 295.925px"
    },
    className: "animable",
    d: "M177 279.31h15.21v33.23H177z",
    id: "eln0ezqwiuyv"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.3,
      transformOrigin: "221.305px 295.925px"
    },
    className: "animable",
    d: "M212.57 279.31h17.47v33.23h-17.47z",
    id: "elk0vsjw221be"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.7,
      transformOrigin: "230.325px 272.81px"
    },
    className: "animable",
    d: "M212.57 268.31h35.51v9h-35.51z",
    id: "el46ke4nazy2s"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.3,
      transformOrigin: "240.07px 295.925px"
    },
    className: "animable",
    d: "M232.05 279.31h16.04v33.23h-16.04z",
    id: "elv5c9k1vi0os"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.5,
      transformOrigin: "168.93px 295.925px"
    },
    className: "animable",
    d: "M162.86 279.31H175v33.23h-12.14z",
    id: "eldcbv194fh1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "168.93px 272.81px"
    },
    id: "elrbqq7rj27nr",
    className: "animable",
    d: "M162.86 268.31H175v9h-12.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.3,
      transformOrigin: "202.39px 295.925px"
    },
    className: "animable",
    d: "M194.21 279.31h16.36v33.23h-16.36z",
    id: "eljdvyc75zsp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.79 326.15a2.17 2.17 0 0 1-2.17-2.17v-12.24a2.17 2.17 0 0 1 2.17-2.17 2.17 2.17 0 0 1 2.17 2.17V324a2.17 2.17 0 0 1-2.17 2.15z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "258.79px 317.86px"
    },
    className: "animable",
    id: "elvgc0ha5cer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74 209.08v104.2h-60.33a3.22 3.22 0 0 1-3.21-3.22v-104.2h60.32a3.22 3.22 0 0 1 3.22 3.22z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "229.97px 259.57px"
    },
    className: "animable",
    id: "ely3bvy9bj0rn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--window-2--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "261.445px 223.75px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp,3s Infinite linear heartbeat",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.71 152.3v125.26l-20.86 20.86h-82.46a3.22 3.22 0 0 1-3.21-3.22V152.3a3.22 3.22 0 0 1 3.21-3.22h100.1a3.22 3.22 0 0 1 3.22 3.22z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "261.445px 223.75px"
    },
    id: "el1dv84ciy3x1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.71 157.77v119.79l-20.86 20.86h-82.46a3.22 3.22 0 0 1-3.21-3.22V157.77z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "261.445px 228.095px"
    },
    className: "animable",
    id: "eldn0snuc08vb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.37,
    cy: 153.06,
    r: 1.55,
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "310.37px 153.06px"
    },
    className: "animable",
    id: "elun35conh9l"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.43,
    cy: 153.06,
    r: 1.55,
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "304.43px 153.06px"
    },
    className: "animable",
    id: "elvcoi3t0hye"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.05 153.06a1.56 1.56 0 1 1-1.55-1.55 1.54 1.54 0 0 1 1.55 1.55z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "298.49px 153.07px"
    },
    className: "animable",
    id: "el827gupmyzmg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.62 168h-20.37a1 1 0 0 1 0-2h20.37a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.435px 167px"
    },
    id: "el7disoq043hg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 173.42h-37.1a1 1 0 0 1 0-2H277a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.45px 172.42px"
    },
    id: "elhkbn69il3ql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.92 178.89H248a1 1 0 0 1 0-2h21a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.5px 177.89px"
    },
    id: "el0jad93hoaqhc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 193.35H228a1 1 0 0 1 0-2h73a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "264.5px 192.35px"
    },
    id: "el1skohb6stko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.84 215.2h-73a1 1 0 0 1 0-2h73a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "252.34px 214.2px"
    },
    id: "elbjip8z6rqbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 198.81h-85.23a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.435px 197.81px"
    },
    id: "els4efz3xudnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 204.28h-85.23a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.435px 203.28px"
    },
    id: "el7v80irgpz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 209.74h-85.23a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.435px 208.74px"
    },
    id: "eljvmzrmh67gr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 248.35H228a1 1 0 0 1 0-2h73a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "264.5px 247.35px"
    },
    id: "elfturxinvbep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.84 270.2h-73a1 1 0 0 1 0-2h73a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "252.34px 269.2px"
    },
    id: "ellqm4g81k3vk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 253.81h-85.23a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.435px 252.81px"
    },
    id: "elwg67k6x7n4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 259.28h-85.23a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.435px 258.28px"
    },
    id: "elmrznkr3aln8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 264.74h-85.23a1 1 0 0 1 0-2h85.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "258.435px 263.74px"
    },
    id: "el4g68ecx60vl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "295.935px 172.57px"
    },
    id: "elpoo4tnvrxqh",
    className: "animable",
    d: "M290.82 165.76h10.23v13.62h-10.23z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.5,
    cy: 171.43,
    r: 5.67,
    style: {
      fill: "#5b9ffa",
      transformOrigin: "221.5px 171.43px"
    },
    id: "eldavtsicgmjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5 222.35a1.2 1.2 0 0 0 2.39 0 1.2 1.2 0 1 0-2.39 0z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "216.695px 222.241px"
    },
    id: "elndbd8i1amot",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5 227.81a1.2 1.2 0 1 0 1.19-1.19 1.19 1.19 0 0 0-1.19 1.19z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "216.7px 227.82px"
    },
    id: "el88uyvpcwd38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5 233.28a1.2 1.2 0 0 0 2.39 0 1.2 1.2 0 1 0-2.39 0z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "216.695px 233.171px"
    },
    id: "elakuth5rkvvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5 238.74a1.2 1.2 0 0 0 2.39 0 1.2 1.2 0 1 0-2.39 0z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "216.695px 238.631px"
    },
    id: "elyopdru62zb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.84 223.35h-13a1 1 0 0 1 0-2h13a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "227.34px 222.35px"
    },
    id: "elw0g6n3uym4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05 228.81h-25.23a1 1 0 0 1 0-2h25.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "233.435px 227.81px"
    },
    id: "elro04g7maah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05 234.28h-10.23a1 1 0 0 1 0-2h10.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "225.935px 233.28px"
    },
    id: "elumuvvllj8jf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.05 239.74h-21.23a1 1 0 0 1 0-2h21.23a1 1 0 0 1 0 2z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "231.435px 238.74px"
    },
    id: "eljfy5gaypvqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      opacity: 0.5,
      transformOrigin: "304.28px 287.99px"
    },
    className: "animable",
    d: "m314.71 277.56-20.86 20.86v-20.86h20.86z",
    id: "elzr74o403abl"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "295.935px 172.57px"
    },
    className: "animable",
    d: "m301.05 165.76-10.23 13.62h10.23v-13.62z",
    id: "eln0k3amtlq2g"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "221.495px 171.435px"
    },
    className: "animable",
    d: "M218.18 168.12h6.63v6.63h-6.63z",
    id: "ellecqehhukgo"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "311.755px 217.665px"
    },
    className: "animable",
    d: "M308.81 157.77h5.89v119.79h-5.89z",
    id: "el1zsystucxbo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76 180.36a2.17 2.17 0 0 1-2.17-2.17V166a2.17 2.17 0 0 1 2.17-2.17 2.17 2.17 0 0 1 2.17 2.17v12.24a2.17 2.17 0 0 1-2.17 2.12z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "311.76px 172.095px"
    },
    id: "elwtcg3tkiod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76 180.36a2.17 2.17 0 0 1-2.17-2.17V166a2.17 2.17 0 0 1 2.17-2.17 2.17 2.17 0 0 1 2.17 2.17v12.24a2.17 2.17 0 0 1-2.17 2.12z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "311.76px 172.095px"
    },
    className: "animable",
    id: "elupsim5oywi"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "101.29px 236.08px",
      animation: "1.5s Infinite linear floating",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.83 208.93h34.92a5.07 5.07 0 0 1 5.06 5.07v33.94a5.06 5.06 0 0 1-5.06 5.06h-14.18l1.53 10.23-7-10.23H83.83a5.05 5.05 0 0 1-5.06-5.06V214a5.06 5.06 0 0 1 5.06-5.07z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "101.29px 236.08px"
    },
    id: "el94sdaev7qdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.83 208.93h34.92a5.07 5.07 0 0 1 5.06 5.07v33.94a5.06 5.06 0 0 1-5.06 5.06h-14.18l1.53 10.23-7-10.23H83.83a5.05 5.05 0 0 1-5.06-5.06V214a5.06 5.06 0 0 1 5.06-5.07z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "101.29px 236.08px"
    },
    className: "animable",
    id: "eljefwy4chmu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.41 223.91v2.71l1.4.13a7.08 7.08 0 0 0 1 2.5l-.89 1.08 1.91 1.91 1.09-.89a7.2 7.2 0 0 0 2.5 1l.13 1.39h2.7l.14-1.39a7.37 7.37 0 0 0 2.5-1l1.08.89 1.91-1.91-.89-1.08a7.28 7.28 0 0 0 1-2.5l1.39-.13v-2.71l-1.39-.13a7.28 7.28 0 0 0-1-2.5l.89-1.08-1.88-1.92-1.08.9a7.37 7.37 0 0 0-2.5-1l-.14-1.4h-2.7l-.13 1.4a7.2 7.2 0 0 0-2.5 1l-1.09-.9-1.86 1.92.89 1.08a7.08 7.08 0 0 0-1 2.5zm8.52-2.31a3.67 3.67 0 1 1-3.66 3.66 3.67 3.67 0 0 1 3.66-3.66z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "106.895px 225.26px"
    },
    id: "elr817y7boef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.16 243.66a5.85 5.85 0 0 0 2-.81l.85.7 1.5-1.5-.7-.85a5.85 5.85 0 0 0 .81-2l1.09-.1V237l-1.09-.1a5.68 5.68 0 0 0-.81-2l.7-.85-1.5-1.5-.85.7a5.47 5.47 0 0 0-2-.81l-.1-1.1h-2.12l-.11 1.1a5.47 5.47 0 0 0-2 .81l-.84-.7-1.5 1.5.7.85a5.51 5.51 0 0 0-.82 2l-1.09.1v2.12l1.09.1a5.67 5.67 0 0 0 .82 2l-.7.85 1.5 1.5.84-.7a5.85 5.85 0 0 0 2 .81l.11 1.09h2.12zm-4-5.58A2.88 2.88 0 1 1 99 241a2.87 2.87 0 0 1-2.88-2.92z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "98.995px 238.055px"
    },
    id: "el93z6f4qezvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.64 231.7.59.71 1.47-1-.45-.81a4.6 4.6 0 0 0 1-1.49l.92.09.33-1.75-.89-.26a4.83 4.83 0 0 0-.36-1.74l.71-.59-1-1.47-.81.44a4.57 4.57 0 0 0-1.49-1l.09-.92-1.75-.31-.26.88a4.63 4.63 0 0 0-1.74.37l-.59-.71-1.47 1 .44.81a4.79 4.79 0 0 0-1 1.49l-.92-.08-.33 1.75.88.25a4.73 4.73 0 0 0 .37 1.75l-.71.59 1 1.47.81-.45a4.82 4.82 0 0 0 1.49 1l-.08.92 1.75.33.25-.89a4.93 4.93 0 0 0 1.75-.38zm-4.21-4.87a2.41 2.41 0 1 1 4.74.89 2.41 2.41 0 0 1-4.74-.89z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "92.815px 227.285px"
    },
    id: "elxevtkon8929",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "142.94px 347.812px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.36 333.12s2.46 22.14 3.26 24.78 12.07 16.74 12.07 16.74l-3.19 1.67s-12-12.34-13.91-16-4.77-22.76-4.77-22.76z",
    style: {
      fill: "#ebb376",
      transformOrigin: "145.755px 354.715px"
    },
    id: "elzeykih5t0sk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11 323.26c4.15 2.2 5.51 32.93 5.51 32.93l2.1 3.23-6.38 4.58a57.34 57.34 0 0 1-4-7.92c-1.27-3.42-4.28-20.3-4.28-20.3z",
    style: {
      fill: "#263238",
      transformOrigin: "139.39px 343.63px"
    },
    id: "ellff4bfjzpjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11 323.26c4.15 2.2 5.51 32.93 5.51 32.93l2.1 3.23-6.38 4.58a57.34 57.34 0 0 1-4-7.92c-1.27-3.42-4.28-20.3-4.28-20.3z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate",
      transformOrigin: "139.39px 343.63px"
    },
    className: "animable",
    id: "el1yrtc44ip8ai"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "143.845px 362.22px"
    },
    id: "eli1g9xts4dxi",
    className: "animable",
    d: "m139.4 363.97 7.32-5.8 1.57 3.29-6.75 4.81-2.14-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "143.845px 362.22px"
    },
    className: "animable",
    d: "m139.4 363.97 7.32-5.8 1.57 3.29-6.75 4.81-2.14-2.3z",
    id: "elep16a49rlmq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.75 362.88 7.48 11.83c14.83-3.45 62.36-10.7 68.19 5.61 7.26 20.26-45.17 36.42-74.18 37.41s-52.3-15.53-33.95-57.83z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "141.437px 388.836px"
    },
    id: "elnkk5mje3l2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.75 362.88 7.48 11.83c14.83-3.45 62.36-10.7 68.19 5.61 7.26 20.26-45.17 36.42-74.18 37.41s-52.3-15.53-33.95-57.83z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "141.437px 388.836px"
    },
    className: "animable",
    id: "elvqmmukqgdbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 409a.2.2 0 0 1-.21 0 .15.15 0 0 1-.05-.18c.09-.33 1.05-3.12 2-3.41a.6.6 0 0 1 .58.17 1 1 0 0 1 .35.94 2.63 2.63 0 0 1-.91 1.31A11.21 11.21 0 0 1 190 409zm.25-.54a4.18 4.18 0 0 0 2.07-2 .64.64 0 0 0-.25-.64.22.22 0 0 0-.23-.07 1 1 0 0 0-.22.13 8.17 8.17 0 0 0-1.35 2.55z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "191.206px 407.211px"
    },
    id: "elwn1948q3tum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 409a.14.14 0 0 1-.18-.05c-.09-.08-1.43-1.77-1.21-2.91a1.06 1.06 0 0 1 .46-.7.62.62 0 0 1 .77-.07c.71.49.62 2.76.28 3.61v.09zm-.76-3.31a.71.71 0 0 0-.23.4 3.93 3.93 0 0 0 .89 2.33c.22-1 .15-2.55-.26-2.84 0 0-.13-.09-.34.06l-.06.05z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "189.481px 407.091px"
    },
    id: "eluapiw783x3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 413.72a.18.18 0 0 1 .19-.09.15.15 0 0 1 .13.13c.07.33.58 3.24-.13 4a.56.56 0 0 1-.58.13 1 1 0 0 1-.76-.65 2.59 2.59 0 0 1 .16-1.58 11.05 11.05 0 0 1 .99-1.94zm0 .59a4.18 4.18 0 0 0-.85 2.74.64.64 0 0 0 .53.44.19.19 0 0 0 .23-.05.61.61 0 0 0 .13-.22 8.13 8.13 0 0 0 .02-2.91z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "138.678px 415.774px"
    },
    id: "el80qcupfbaw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebb376",
      transformOrigin: "150.63px 405.325px"
    },
    id: "el7k3aamms5d",
    className: "animable",
    d: "m158.01 399.04-11.94 4.25-5.73 2.04 1.47 6.28 5.55-1.19 13.56-2.89-2.91-8.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.37 411.9-1-7.4a.74.74 0 0 0-.86-.63l-3.65.61s-5 .47-6 1.74c-2.89 3.73-1.09 20.15.84 20.73.7.21 1.44-.75 1.75-1.42 1-2.12 2.69-7.65 3.52-9.41 1-2.05 3.64-3.05 4.84-3.41a.74.74 0 0 0 .56-.81z",
    style: {
      fill: "#263238",
      transformOrigin: "136.861px 415.419px"
    },
    id: "el6y174n8t316",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.05 413.66a.17.17 0 0 1 .18 0c.12 0 2.11.86 2.47 2a1.11 1.11 0 0 1-.07.84.63.63 0 0 1-.64.44c-.85-.09-1.88-2.12-2-3v-.09a.18.18 0 0 1 .06-.19zm2.27 2.54a.76.76 0 0 0 0-.47c-.23-.7-1.34-1.32-1.91-1.6.28.95 1.11 2.31 1.61 2.36 0 0 .15 0 .26-.21v-.08z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "140.367px 415.288px"
    },
    id: "elr5r9rqr72i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "153.495px 404.73px"
    },
    className: "animable",
    d: "m158.01 399.04-11.94 4.25 1.29 7.13 13.56-2.89-2.91-8.49z",
    id: "eljx84vytiz4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "149.815px 405.835px"
    },
    id: "el0v6uneipbtb",
    className: "animable",
    d: "m149.47 411.5 3.44.24-2.3-11.81-3.89 2.16 2.75 9.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "149.815px 405.835px"
    },
    className: "animable",
    d: "m149.47 411.5 3.44.24-2.3-11.81-3.89 2.16 2.75 9.41z",
    id: "el0oodzex0psy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.68 365.6 17.88 19.83s19.77-.44 43.77 11.29c0 0 25.75-10.64 28.12-19.48 3.1-11.58-59.22-2.53-59.22-2.53z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "144.621px 381.16px"
    },
    className: "animable",
    id: "elwgss8uiuku"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54 379.6v2.94c0 .75-.89 1.06-1.63 1.06H123.2c-.75 0-1.66-.31-1.66-1.06v-2.94z",
    style: {
      fill: "#263238",
      transformOrigin: "152.54px 381.6px"
    },
    id: "elt7qrc7xif4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54 379.6v2.94c0 .75-.89 1.06-1.63 1.06H123.2c-.75 0-1.66-.31-1.66-1.06v-2.94z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "152.54px 381.6px"
    },
    className: "animable",
    id: "elvx7z66m0gz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54 379.6v2.94c0 .75-.89 1.06-1.63 1.06h-38.72c-.75 0-1.65-.31-1.65-1.06v-2.94z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "162.54px 381.6px"
    },
    className: "animable",
    id: "elf6xkpu0eo1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.36 349.1-7 31.7a2.39 2.39 0 0 1-2.27 1.8h-38.16a1.53 1.53 0 0 1-1.43-2l7-31.46a2.17 2.17 0 0 1 2.26-1.55h38.18c1.06.01 1.65.48 1.42 1.51z",
    style: {
      fill: "#263238",
      transformOrigin: "168.918px 365.091px"
    },
    id: "elypw23g0tcn9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.36 349.1-7 31.7a2.39 2.39 0 0 1-2.27 1.8h-36.86a1.55 1.55 0 0 1-1.45-2l7-31.46a2.19 2.19 0 0 1 2.22-1.54h36.88c1.12 0 1.71.47 1.48 1.5z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "169.561px 365.098px"
    },
    className: "animable",
    id: "el8t3luc5jm2v"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.54 365.21c0 2.72-2.91 4.92-5 4.92s-3.4-2.2-2.79-4.92 2.73-4.83 4.82-4.91c-.61 2.72.69 4.91 2.82 4.91a1 1 0 0 0 .15 0z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "170.57px 365.215px"
    },
    className: "animable",
    id: "elsj56t2xn4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebb376",
      transformOrigin: "176.425px 409.725px"
    },
    id: "elck44syb82lg",
    className: "animable",
    d: "m166.3 412.62 12.5 2.06 6 .99 1.75-6.2-5.43-1.66-13.26-4.03-1.56 8.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.33 408.45-2.7 7a.73.73 0 0 0 .44 1l3.49 1.23s4.57 2 6.05 1.36c4.33-1.86 10.7-17.11 9.3-18.54-.51-.53-1.63 0-2.22.39-1.88 1.38-6.06 5.4-7.63 6.53-1.85 1.32-4.67.91-5.89.65a.72.72 0 0 0-.84.38z",
    style: {
      fill: "#263238",
      transformOrigin: "192.335px 409.722px"
    },
    id: "eleudap509w2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "173.71px 409.23px"
    },
    className: "animable",
    d: "m166.3 412.62 12.5 2.06 2.32-6.87-13.26-4.03-1.56 8.84z",
    id: "elodpmhz93ng"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 406.52s-51-28.66-68.56-27.84-20.13 16.32-12.87 26 20.66 12.06 20.66 12.06-9.13-12.89-7.81-16.52 6.48 1.44 6.48 1.44S148.94 412 177 414.42z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "136.388px 397.701px"
    },
    id: "el6mfdashbteq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "176.495px 409.485px"
    },
    id: "eln93zgix51gl",
    className: "animable",
    d: "m179.79 405.73-2.88-1.94-3.71 11.39h4.45l2.14-9.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "176.495px 409.485px"
    },
    className: "animable",
    d: "m179.79 405.73-2.88-1.94-3.71 11.39h4.45l2.14-9.45z",
    id: "elfrmai0xkafv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.29 359.9 32.47 3s5.09-10.54 9-14.65 7.36-25 7.36-25a69.34 69.34 0 0 0-8.14-3.32 80.68 80.68 0 0 0-24.84-4.18H106c-2.42 0-3.82.12-3.82.12a6.9 6.9 0 0 0-2.31 2.63c-3.48 6-6.25 20-7.89 30.05-1.11 6.5-1.69 11.35-1.69 11.35z",
    style: {
      fill: "#263238",
      transformOrigin: "114.705px 339.325px"
    },
    id: "elbr4qt4ku0z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.93 348.56c7.16-3.28 16.93-8.83 16.42-14.46-.55-6.18-5.56-12.4-8.53-15.59-3.48 6-6.25 20-7.89 30.05z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "100.15px 333.535px"
    },
    className: "animable",
    id: "el7hxozo75y57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.72 315.79s3.7 12.18 13.82 13.5 11.8-8.5 11.8-8.5-13.03-7.15-25.62-5z",
    style: {
      fill: "#263238",
      transformOrigin: "120.53px 322.399px"
    },
    id: "eli5ychftowi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.72 315.79s3.7 12.18 13.82 13.5 11.8-8.5 11.8-8.5-13.03-7.15-25.62-5z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate",
      transformOrigin: "120.53px 322.399px"
    },
    className: "animable",
    id: "elw77apabqq5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.84 316.13s4.77 11.28 13.37 11.28 8.87-6.33 8.87-6.33-8.6-5.64-22.24-4.95z",
    style: {
      fill: "#5b9ffa",
      transformOrigin: "120.96px 321.741px"
    },
    id: "elgnggnqanrcr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.84 316.13s4.77 11.28 13.37 11.28 8.87-6.33 8.87-6.33-8.6-5.64-22.24-4.95z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "120.96px 321.741px"
    },
    className: "animable",
    id: "elkdn6l8ulv2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41 317.89c.06 2 1.21 2.5 1.21 2.5a4.1 4.1 0 0 1-4.45 4.73c-6.37-.65-8.38-8.32-8.38-8.32 4.63-1.84 5.67-6.95 5.87-10a16.8 16.8 0 0 0 0-2.38l8.66 5.45a30.32 30.32 0 0 0-1.93 3.79 10.84 10.84 0 0 0-.98 4.23z",
    style: {
      fill: "#ebb376",
      transformOrigin: "121.055px 314.78px"
    },
    id: "elsjuio42mfrd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79 309.2a31.44 31.44 0 0 0-1.54 4 10.74 10.74 0 0 0-.54 4.29c-4.87.38-6.81-10.37-6.81-10.37v-.07a16.26 16.26 0 0 0-.24-2.37z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "123.225px 311.09px"
    },
    className: "animable",
    id: "elvefx3pnvegq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.33 285.18s6.36-7.32-1.25-13.45-22.64-3.37-25.41 10.48 1 19.7 1 19.7 0-8.82 2.54-11.39c0 0-.76 4.22 0 6.75s0 .93 0 .93 2.34-11.05 13.62-7.88 9.5-5.14 9.5-5.14z",
    style: {
      fill: "#263238",
      transformOrigin: "120.737px 285.277px"
    },
    id: "elxt1qde5tlt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.85 287.56c8.38 2.56 9.71 7.86 7.69 16.68-2.52 11-7.25 18-17 12.46-13.3-7.47-4.6-33.38 9.31-29.14z",
    style: {
      fill: "#ebb376",
      transformOrigin: "131.156px 302.867px"
    },
    id: "elksd18znclr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.27 302.12a18.47 18.47 0 0 0 1.37 4.22 2.4 2.4 0 0 1-2.49.28z",
    style: {
      fill: "#d58745",
      transformOrigin: "137.395px 304.483px"
    },
    id: "elzvi3qyhtglr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.35 299.88c-.2.69-.73 1.15-1.19 1s-.68-.8-.49-1.49.73-1.15 1.19-1 .68.79.49 1.49z",
    style: {
      fill: "#263238",
      transformOrigin: "131.51px 299.635px"
    },
    id: "el7v7j1ns5ubw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.66 298.37 1.67-.17s-1.1 1.06-1.67.17z",
    style: {
      fill: "#263238",
      transformOrigin: "132.495px 298.463px"
    },
    id: "elgdclm7jtu9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 302.14c-.19.69-.72 1.15-1.18 1s-.68-.8-.49-1.49.73-1.15 1.19-1 .68.8.48 1.49z",
    style: {
      fill: "#263238",
      transformOrigin: "140.168px 301.895px"
    },
    id: "elp4e25tqb1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.32 300.63 1.67-.17s-1.11 1.06-1.67.17z",
    style: {
      fill: "#263238",
      transformOrigin: "141.155px 300.723px"
    },
    id: "eliox22pqcnc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 294.59a.37.37 0 0 1-.2-.67 4.85 4.85 0 0 1 4.37-.18.36.36 0 0 1 .18.47.36.36 0 0 1-.48.19 4.22 4.22 0 0 0-3.67.12.31.31 0 0 1-.2.07z",
    style: {
      fill: "#263238",
      transformOrigin: "132.013px 293.948px"
    },
    id: "el5uafeswd70o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.35 297.64a.39.39 0 0 1-.28-.13 3.69 3.69 0 0 0-2.83-1.58.37.37 0 0 1-.38-.34.36.36 0 0 1 .34-.38 4.36 4.36 0 0 1 3.43 1.83.37.37 0 0 1 0 .52.38.38 0 0 1-.28.08z",
    style: {
      fill: "#263238",
      transformOrigin: "141.798px 296.426px"
    },
    id: "elrrrb992nm38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.39 298.89s6-5.69 7-11.18c0 0 18.67-1.72 14.35 15.38 0 0 6.19-14.47-8.11-19.19s-20.63 16.36-15.1 24.9c0 0-1.87-6.35 1.86-9.91z",
    style: {
      fill: "#263238",
      transformOrigin: "130.808px 296.01px"
    },
    id: "el61tok170jro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.22 310.39a4.64 4.64 0 0 1-4.63-3.93.38.38 0 0 1 .32-.41.37.37 0 0 1 .4.32 3.87 3.87 0 0 0 3.93 3.3.36.36 0 0 1 0 .72z",
    style: {
      fill: "#263238",
      transformOrigin: "132.094px 308.219px"
    },
    id: "elk3jtwrpua3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94 297.21a.25.25 0 0 0 .13.28h.06l8.53 2a3.7 3.7 0 0 0 2.15 4 4.46 4.46 0 0 0 5.72-1.55 3.15 3.15 0 0 0 .26-.56 1.46 1.46 0 0 1 1.1-.32.79.79 0 0 1 .44.51 3.72 3.72 0 0 0 2.16 3.93 4.47 4.47 0 0 0 5.72-1.56 3.63 3.63 0 0 0-1.72-5.16 4.46 4.46 0 0 0-5.72 1.55 3.15 3.15 0 0 0-.26.56 1.15 1.15 0 0 0-.43-.28 1.59 1.59 0 0 0-1.11.12 3.71 3.71 0 0 0-2.16-4 4.46 4.46 0 0 0-5.72 1.55 3.73 3.73 0 0 0-.33.74l-8.49-2a.27.27 0 0 0-.33.19zm19.3 3.31a3.91 3.91 0 0 1 5-1.36 3.18 3.18 0 0 1 1.5 4.52 3.9 3.9 0 0 1-5 1.35 3.17 3.17 0 0 1-1.5-4.51zm-9.68-2a3.91 3.91 0 0 1 5-1.36 3.18 3.18 0 0 1 1.5 4.52 3.9 3.9 0 0 1-5 1.36 3.19 3.19 0 0 1-1.5-4.53z",
    style: {
      fill: "#263238",
      transformOrigin: "133.316px 301.112px"
    },
    id: "eliwll2v4mptq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      isolation: "isolate",
      transformOrigin: "133.316px 301.112px"
    },
    className: "animable",
    id: "el2osvipr2aov"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.94 297.21a.25.25 0 0 0 .13.28h.06l8.53 2a3.7 3.7 0 0 0 2.15 4 4.46 4.46 0 0 0 5.72-1.55 3.15 3.15 0 0 0 .26-.56 1.46 1.46 0 0 1 1.1-.32.79.79 0 0 1 .44.51 3.72 3.72 0 0 0 2.16 3.93 4.47 4.47 0 0 0 5.72-1.56 3.63 3.63 0 0 0-1.72-5.16 4.46 4.46 0 0 0-5.72 1.55 3.15 3.15 0 0 0-.26.56 1.15 1.15 0 0 0-.43-.28 1.59 1.59 0 0 0-1.11.12 3.71 3.71 0 0 0-2.16-4 4.46 4.46 0 0 0-5.72 1.55 3.73 3.73 0 0 0-.33.74l-8.49-2a.27.27 0 0 0-.33.19zm19.3 3.31a3.91 3.91 0 0 1 5-1.36 3.18 3.18 0 0 1 1.5 4.52 3.9 3.9 0 0 1-5 1.35 3.17 3.17 0 0 1-1.5-4.51zm-9.68-2a3.91 3.91 0 0 1 5-1.36 3.18 3.18 0 0 1 1.5 4.52 3.9 3.9 0 0 1-5 1.36 3.19 3.19 0 0 1-1.5-4.53z",
    style: {
      fill: "#fff",
      transformOrigin: "133.316px 301.112px"
    },
    id: "elcx9gndg96tr",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.22 301.07a3.84 3.84 0 0 0-2.93-4.56c-2.68-.51-5.55 4.44.52 7.69.87.47 1.67-.28 2.41-3.13z",
    style: {
      fill: "#ebb376",
      transformOrigin: "119.259px 300.402px"
    },
    id: "elnwqnqv47eq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 326.82s1 21.38 2.81 26.18 20.69 22.48 20.69 22.48 5.27-1.17 6.14-.83 5.9 5 5.9 5H127l-1.27-2.24s-19.54-14.48-21.69-17.93c-1.59-2.55-6.7-28.52-6.7-28.52z",
    style: {
      fill: "#ebb376",
      transformOrigin: "119.44px 353.235px"
    },
    id: "el0jseijpebxn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13 315.88c3.39-1.76 5 3.91 7.07 15.38a120.63 120.63 0 0 1 1.69 21.95l2.9 5.15-7.32 6.74a31.42 31.42 0 0 1-7.71-11.89c-2.26-6.9-8.49-31.14 3.37-37.33z",
    style: {
      fill: "#263238",
      transformOrigin: "104.444px 340.332px"
    },
    id: "elhl3oznjn9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13 315.88c3.39-1.76 5 3.91 7.07 15.38a120.63 120.63 0 0 1 1.69 21.95l2.9 5.15-7.32 6.74a31.42 31.42 0 0 1-7.71-11.89c-2.26-6.9-8.49-31.14 3.37-37.33z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate",
      transformOrigin: "104.444px 340.332px"
    },
    className: "animable",
    id: "eleuz80eo4usu"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b9ffa",
      transformOrigin: "110.265px 362.425px"
    },
    id: "eljz0zxziqpmm",
    className: "animable",
    d: "m104.56 365.1 9.23-8.25 2.18 3.05-8.25 8.1-3.16-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "110.265px 362.425px"
    },
    className: "animable",
    d: "m104.56 365.1 9.23-8.25 2.18 3.05-8.25 8.1-3.16-2.9z",
    id: "el9sk92s74pbd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDocument);
export default __webpack_public_path__ + "static/media/empty-document.361b7cb7eb9a96861415ce308bc2b6bb.svg";
export { ForwardRef as ReactComponent };